import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import { display, overflow } from 'styled-system';
import type { DisplayProps, OverflowProps } from 'styled-system';

import type { TextOverflowProps, WhiteSpaceProps } from '../../../theme/system-utilities';
import { textOverflow, whiteSpace } from '../../../theme/system-utilities';
import { BodyRegularBR2 } from '../../Typography';
import type { GroupedVariation } from '../utils/utils';

interface OtherVariationsProps {
  otherVariations: GroupedVariation[];
  clickTrackingHandler: ({ target }: React.MouseEvent<Element, MouseEvent>) => void;
}

const VariationsContainer = styled(BodyRegularBR2)<
  WhiteSpaceProps & OverflowProps & TextOverflowProps & DisplayProps
>`
  ${whiteSpace};
  ${overflow};
  ${textOverflow};
`;

const otherVariationsStyles: ComponentProps<typeof VariationsContainer> = {
  mr: 'sp_4',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

const VariationGroup = styled(BodyRegularBR2)<DisplayProps>`
  ${display};
`;

const variationGroupStyles: ComponentProps<typeof VariationGroup> = {
  as: 'span',
  display: 'inline-block',
};

const OtherVariations = ({ clickTrackingHandler, otherVariations }: OtherVariationsProps) => {
  return (
    <VariationsContainer
      {...otherVariationsStyles}
      data-type="variations"
      onClick={clickTrackingHandler}
    >
      {otherVariations.map(({ title, count }, index) => (
        <VariationGroup {...variationGroupStyles} key={`${title}-${count}`}>
          {index > 0 && <span key="separator">&nbsp;• </span>}
          {title} ({count})
        </VariationGroup>
      ))}
    </VariationsContainer>
  );
};

export default OtherVariations;
